import type { ReactNode } from 'react';

/**
 * The surface every panel on the site sits on: white, hairline border, soft
 * shadow, 16px corners. `interactive` adds the hover lift used by clickable
 * cards (categories, jobs).
 */
export function Card({
  children,
  className = '',
  as: Tag = 'div',
  interactive = false,
  padded = true,
}: {
  children: ReactNode;
  className?: string;
  as?: 'div' | 'section' | 'article' | 'li';
  interactive?: boolean;
  padded?: boolean;
}) {
  return (
    <Tag
      className={`rounded-2xl border border-line bg-white shadow-soft ${padded ? 'p-6' : ''} ${
        interactive
          ? 'transition duration-200 ease-out hover:-translate-y-0.5 hover:border-brand-200 hover:shadow-lift'
          : ''
      } ${className}`}
    >
      {children}
    </Tag>
  );
}

/** Small uppercase heading used on the dashboard panels. */
export function CardHeading({ children, action }: { children: ReactNode; action?: ReactNode }) {
  return (
    <div className="flex items-center justify-between gap-3">
      <h2 className="text-xs font-bold tracking-[0.08em] text-slate-500 uppercase">{children}</h2>
      {action}
    </div>
  );
}
